import { useState } from "react";
import { Sparkles, Check, X, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const TONE = { Hot: "bg-rose-50 text-rose-700 border-rose-200", Warm: "bg-amber-50 text-amber-800 border-amber-200", Cold: "bg-sky-50 text-sky-700 border-sky-200" };

export default function InterestSuggestion({ contact, reload }) {
  const [busy, setBusy] = useState(false);
  const s = contact.interest_suggestion;
  const run = async () => {
    setBusy(true);
    try { await api.post(`/contacts/${contact.id}/score-interest`); reload(); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  const resolve = async (action) => {
    try { await api.post(`/contacts/${contact.id}/interest-suggestion`, { action }); toast.success(action === "accept" ? `Interest set to ${s.level}` : "Suggestion dismissed"); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  const pending = s?.status === "pending" && s.level && s.level !== contact.interest_level;
  return (
    <div className="mb-5 rounded-2xl border border-violet-100 bg-violet-50/40 p-4" data-testid="interest-suggestion">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="flex items-center gap-2 text-sm font-bold"><Sparkles className="h-4 w-4 text-violet-600" />Lead score
          <span className="font-normal text-slate-500">— current: <b data-testid="interest-current">{contact.interest_level || "not set"}</b></span></p>
        <button data-testid="interest-suggest-btn" disabled={busy} onClick={run} className="cd-btn-ghost h-8 px-2 text-xs"><RefreshCw className={`h-3.5 w-3.5 ${busy ? "animate-spin" : ""}`} />{s ? "Re-score from notes" : "Suggest from notes"}</button>
      </div>
      {s && (
        <div className="mt-2 text-sm">
          {s.level ? (
            <>
              <p><span className="rounded bg-violet-100 px-1.5 py-0.5 text-[10px] font-bold text-violet-700">AI SUGGESTION</span>{" "}
                <span data-testid="interest-suggested-level" className={`rounded-full border px-2 py-0.5 text-xs font-bold ${TONE[s.level]}`}>{s.level}</span>
                <span className="ml-1 text-xs text-slate-500">{s.confidence} confidence · from {s.notes_count} note(s)</span></p>
              <p className="mt-1 text-slate-700" data-testid="interest-reason">{s.reason}</p>
              {s.signals?.length > 0 && <ul className="mt-1 list-disc pl-5 text-xs text-slate-600">{s.signals.map((x, i) => <li key={i}>{x}</li>)}</ul>}
              {pending && (
                <div className="mt-2 flex gap-2">
                  <button data-testid="interest-accept-btn" onClick={() => resolve("accept")} className="cd-btn-primary h-9 px-3"><Check className="h-4 w-4" />Use {s.level}</button>
                  <button data-testid="interest-dismiss-btn" onClick={() => resolve("dismiss")} className="cd-btn-ghost h-9 px-3"><X className="h-4 w-4" />Dismiss</button>
                </div>
              )}
              {s.status === "dismissed" && <p className="mt-1 text-xs text-slate-400">Dismissed</p>}
            </>
          ) : <p className="text-slate-600" data-testid="interest-insufficient">{s.reason || "Not enough information in your notes to judge."}</p>}
        </div>
      )}
      {!s && <p className="mt-1 text-xs text-slate-500">Suggestions use only your notes and deal fields (next action, MOQ, prices) — never the card alone. Adding a note scores automatically.</p>}
    </div>
  );
}
